<template>
   <div id="main-container">
      <job-schedule-edit
         ref="ref_jobScheduleEdit"
         :visible="modalState_editJob"
         @mutatedJob="mutatedJob"
      />
      <div class="col-2" id="div-query-panel" style="max-height: 200px">
         <div id="customer-order-index-query"
            class="card col-2 bg-light"
            v-bind:style="{
               height: `${tHeight}px`,
               position: 'fixed',
               'max-width': '16.2%',
               'overflow-y': 'scroll',
            }"
         ><!-- div -->
            <div class="card-body bg-light px-0" style="background: #f2f2f2">
               <!--form @submit.prevent="onSubmit" -->
               <label class="col-12 px-0">
                  <!-- span v-if="'name' === query.type">Titel:</span -->
                  <!-- span v-else>Klasse:</span -->
                  <b-row class="py-2">
                     <b-col class="pr-3">
                        <b-button-group class="mt-3">
                           <b-button
                              :variant="('name' === query.type) ? 'primary' : 'outline-secondary'"
                              @click="query.type = 'name'"
                              size="sm"
                           >Titel</b-button>
                           <b-button
                              :variant="('name' !== query.type) ? 'primary' : 'outline-secondary'"
                              @click="query.type = 'className'"
                              size="sm"
                           >Klasse</b-button>
                        </b-button-group>
                     </b-col>
                  </b-row>
                  <b-input
                     ref="refInputQuery"
                     class="col-12"
                     size="sm"
                     type="text"
                     v-model="query.string"
                     @keypress.enter="submit()"
                  ></b-input>
               </label>
               <b-row class="pt-2">
                  <b-col class="pr-3">
                     <b-button
                        id="submit-button"
                        block size="sm"
                        variant="primary"
                        @click="submit()"
                     ><!-- button -->
                        filtern
                     </b-button>
                  </b-col>
               </b-row>
               <b-row class="pt-2">
                  <b-col class="pr-3">
                     <b-button
                        id="clear-button"
                        block size="sm"
                        variant="secondary"
                        @click="clear()"
                     ><!-- button -->
                        clear
                     </b-button>
                  </b-col>
               </b-row>
               <div v-for="ff in fastFilterStrings" :key="ff" class="pr-1">
                  <b-row class="pt-2 pr-3">
                     <b-col class="pr-0 my-1">
                        <b-button
                           block size="sm"
                           variant="outline-primary"
                           @click="fastFilter(ff)"
                        ><!-- button -->
                           {{ ff }}
                        </b-button>
                     </b-col>
                  </b-row>
               </div>
            </div>
         </div>
      </div>
      <div class="col-10 float-right">
         <b-overlay
            id="overlay-coi-list-card"
            :show="queryInProgress"
            variant="light"
            opacity="0.5"
            blur="2px"
            rounded="lg"
         ><!-- overlay -->
            <b-card>
               <div class="row" id="coi-pagination">
                  <div class="col-md-2">
                     <div class="d-flex justify-content-start">
                        <h3>Job Schedule</h3>
                     </div>
                  </div>
                  <div class="col-md-10">
                     <div class="d-flex flex-row justify-content-end">
                        <div class="d-flex flex-row-reverse">
                           <div class="pl-2 py-2">
                              <b-button size="md" @click="createJob()">Job hinzufügen</b-button>
                           </div>
                           <div class="py-2">
                              <b-form-select
                                 id="per-page-select"
                                 v-model="perPage"
                                 :options="pageOptions"
                                 size="md"
                              ></b-form-select>
                           </div>
                           <div class="p-2">
                              <b-pagination
                                 id="table-pagination-job-schedule"
                                 class="float-right"
                                 v-if="jobs"
                                 v-model="currentPage"
                                 :total-rows="jobs.filter(filterFunction).length"
                                 :per-page="perPage"
                                 aria-controls="table-job-schedule"
                              ></b-pagination>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>

               <b-table
                  class="mt-3"
                  :items="jobs"
                  :fields="fields"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter-function="filterFunction"
                  :filter="query.regexPattern"
                  small striped hover
               ><!-- b-table -->
                  <template v-slot:cell(currentState)="job">
                     <div v-if="job.item.currentState == 0">🟡 0</div>
                     <div v-else-if="job.item.currentState == 1 && job.item.currentNode">🟢 1</div>
                     <div v-else-if="job.item.currentState == 1">🔴 1</div>
                     <div v-else>⚫ {{ job.item.currentState }}</div> <!-- 🔴🟠🟡🟢🔵🟣⚫⚪🟤 -->
                  </template>
                  <template v-slot:cell(className)="job">
                     <div>
                        {{ job.item.className }}
                        <b-badge
                           variant="info"
                           v-if=" '_D' === job.item.className.substr(job.item.className.length - 2, 2)"
                        >DEV</b-badge>
                        <b-badge variant="warning" v-if="'C2_' === job.item.className.substr(0, 3)"> C++ </b-badge>
                     </div>
                  </template>
                  <template v-slot:cell(name)="job">
                     <div v-if="'[OFF]' !== job.item.name.substr(0, 5)">
                        <a @click="editJob(job.item)" class="link2">{{
                           job.item.name
                        }}</a>
                     </div>
                     <div v-else>
                        <b-badge variant="danger">[OFF]</b-badge>
                        <a @click="editJob(job.item)" class="link2">{{
                           job.item.name.substr(5, job.item.name.length)
                        }}</a>
                     </div>
                  </template>
                  <template v-slot:cell(lastUpdateTime)="job">
                     {{ getTimeDiff(job.item.lastUpdateTime) }}
                  </template>
               </b-table>
            </b-card>
         </b-overlay>
      </div>
   </div>
</template>
<style scoped>
.link2 {
   color: #131313 !important;
}
.link2:hover {
   color: #25bf43 !important;
   cursor: pointer;
}
</style>
<script>
import JobScheduleEdit from "./JobScheduleEdit.vue";
export default {
   components: { JobScheduleEdit },
   props: [ 'passedJobScheduleId' ],
   data() {
      return {
         //moment: moment,
         queryInProgress: false,
         jobs: [],
         jobEdit: null, // job to be edited
         modalState_editJob: false,
         fields: [
            { key: "id", label: "ID", sortable: true },
            { key: "name", label: "Titel", sortable: true },
            { key: "className", label: "className", sortable: true },
            { key: "currentState", label: "Status", sortable: true },
            //   , { key: "lastUpdateTime", label: "Update", sortable: true }
         ],
         perPage: 1000,
         currentPage: 1,
         pageOptions: [25, 100, 250, 1000],
         tHeight: this.window.innerHeight - 75,
         query: {
            setQueryType: function(newType) { this.type = newType; },
            type: 'name',
            string: null,
            regexPattern: null,
         },
         fastFilterStrings: [
            "Fulfillment",
            "Vendor Import",
            "Lager",
            "\\[OFF\\]",
            "Delivery Note",
         ],
      };
   },
   watch: {
      modalState_editJob: function(newState) {
         if(newState) window.history.pushState("", "", '/jobschedule');
      }
   },
   computed: {},
   methods: {
      mutatedJob(mutant) {
         const idx = this.jobs.findIndex((x) => x.id === mutant.id);
         if (-1 === idx) {
            // push the new mutant in the list of existing jobs
            this.jobs.push(mutant);
         } else {
            // replace the old job with the mutant.
            this.jobs.splice(idx, 1, mutant);
         }
      },
      createJob() {
         this.editJob({
            id: null,
            jobarguments: [],
            name: "",
            description: "",
            className: "",
            packageName: "",
            jobType: "",
            preferedNode: "",
            priority: "",
            period: "",
            frequency: "",
            firstRun: "",
            nextRun: "",
            lastRun: "",
            allowedRunTimeStart: "",
            allowedRunTimeEnd: "",
            currentState: "",
            currentNode: "",
            currentStartTime: "",
            lastUpdateTime: "",
            lastUpdateUser: "",
            lastUpdateReason: "",
         });
      },
      editJob(job) {
         this.$bvToast.toast("Daten werden erneut geladen...", {
            title: "Server Anfrage läuft",
            autoHideDelay: 750,
            appendToast: false
         });
         if(job.id === null)
         {
            this.jobEdit = job; //TODO jobEdit is not necessary.
            this.modalState_editJob = true;
            this.$refs.ref_jobScheduleEdit.open(job);  
         }
         else
         {
            this.getJobs().then( () => {
               job = this.jobs.find(j => j.id === job.id); // the reloaded job
               this.jobEdit = job; //TODO jobEdit is not necessary.
               this.modalState_editJob = true;
               this.$refs.ref_jobScheduleEdit.open(job);
            });
         }
      },
      fastFilter(str) {
         this.query.string = str;
         this.submit();
      },
      filterFunction(job) {
         if(this.query.regexPattern)
            return  this.query.regexPattern.test(('name' === this.query.type) ? job.name : job.className);
         return "";
      },
      clear() {
         this.query.string       = null;
         this.query.regexPattern = null;
         this.submit();
      },
      submit() {
         this.query.regexPattern = (this.query.string) ? new RegExp(this.query.string, "i") : null;
      },
      getJobs(delay) {
         return new Promise( (resolve, reject) => {
            this.queryInProgress = true;
            Promise.all([
               axios.get("/jobschedule/all"),
               new Promise((r) => setTimeout(r, delay)),
            ]).then( ([response]) => {
               this.jobs = response.data;
               this.jobs.sort( (v, w) => w.id - v.id );
               this.queryInProgress = false;
               resolve();
            })
            .catch( error => {
               this.$bvToast.toast("Job Schedule", {
                  title: "Kontye job nicht vom Server holen.",
                  autoHideDelay: 9000,
                  appendToast: false,
                  variant: 'danger'
               });
               this.queryInProgress = false;
               console.error(error);
               reject();
            });
         });
      }
   },
   created() {
      if( (!this.passedJobScheduleId)
       || (this.passedJobScheduleId == -1) 
       || (this.passedJobScheduleId == "-1")
      ) return this.getJobs(900);

      axios.get(`/jobschedule/${this.passedJobScheduleId}/get`).then( response => {
         this.jobEdit = response.data;
         this.modalState_editJob = true;
         this.$refs.ref_jobScheduleEdit.open(this.jobEdit);
         return this.getJobs();
      });
   },
   mounted: function() {
      this.$nextTick( function () {
         window.addEventListener( 'keyup', event => {
            if(/*event.altKey &&*/ event.keyCode === 191 && !this.modalState_editJob) //alter
               this.$refs.refInputQuery.focus();
         })
      });
   }
};
</script>
